export type FontFamilyType =
  | 'ariel'
  | 'bitter'
  | 'courier'
  | 'didot'
  | 'garamond'
  | 'georgia'
  | 'helvetica'
  | 'lora'
  | 'lucida-console'
  | 'helvetica-neue-condensed-black'
  | 'space-grotesk'
  | 'merriweather'
  | 'monaco'
  | 'montserrat'
  | 'open-sans'
  | 'palatino'
  | 'playfair-display'
  | 'poppins'
  | 'roboto'
  | 'times-new-roman'
  | 'trebuchet-ms'
  | 'verdana';

export const FONT_FAMILIES: any = {
  ariel: 'font-ariel',
  bitter: 'font-bitter',
  courier: 'font-courier',
  didot: 'font-didot',
  garamond: 'font-garamond',
  georgia: 'font-georgia',
  helvetica: 'font-helvetica',
  lora: 'font-lora',
  'lucida-console': 'font-lucida-console',
  merriweather: 'font-merriweather',
  monaco: 'font-monaco',
  'helvetica-neue-condensed-black': 'font-helvetica-neue-condensed-black',
  'space-grotesk': 'font-space-grotesk',
  montserrat: 'font-montserrat',
  'open-sans': 'font-open_sans',
  palatino: 'font-palatino',
  'playfair-display': 'font-playfair-display',
  poppins: 'font-poppins',
  roboto: 'font-roboto',
  'times-new-roman': 'font-times-new-roman',
  'trebuchet-ms': 'font-trebuchet-ms',
  verdana: 'font-verdana',
};

export type FontSizes = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl';
